import script from "./VVVApplicationsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./VVVApplicationsTable.vue?vue&type=script&setup=true&lang=js"

import "./VVVApplicationsTable.vue?vue&type=style&index=0&id=131c03f6&scoped=true&lang=css"
import "./VVVApplicationsTable.vue?vue&type=style&index=1&id=131c03f6&lang=css"

import exportComponent from "D:\\a\\1\\s\\CSD.SPA\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-131c03f6"]])

export default __exports__